<template>
  <main class="sf-page">
    <div class="sf-page-hero">
      <div class="sf-page-hero__inner" data-aos="fade-up">
        <p class="sf-page-hero__eyebrow"><span class="sf-page-hero__eyebrow-dot"></span>Parlons-nous</p>
        <h1 class="sf-h1">Contactez-<em>nous</em></h1>
        <p class="sf-page-hero__sub">Une question ? Un projet ? N'hésitez pas à nous écrire</p>
      </div>
    </div>

    <section class="sf-section sf-section--cream">
      <div class="sf-container">
        <div class="ct-grid">
          <!-- Form -->
          <div class="ct-form-card" data-aos="fade-right" data-aos-duration="700">
            <h2 class="sf-h2" style="margin-bottom:1.75rem">Envoyez-nous un <em>message</em></h2>
            <div v-if="loading" class="sf-loader"><span class="sf-loader__ring"></span></div>
            <form v-else @submit.prevent="handleSubmit" class="ct-form">
              <div class="ct-form__row">
                <div>
                  <label class="sf-input-label sf-input-label--req">Prénom</label>
                  <input v-model="form.first_name" type="text" class="sf-input" placeholder="Votre prénom" required />
                </div>
                <div>
                  <label class="sf-input-label sf-input-label--req">Nom</label>
                  <input v-model="form.last_name" type="text" class="sf-input" placeholder="Votre nom" required />
                </div>
              </div>
              <div>
                <label class="sf-input-label sf-input-label--req">Email</label>
                <input v-model="form.email" type="email" class="sf-input" placeholder="votre.email@exemple.com" required />
              </div>
              <div>
                <label class="sf-input-label">Téléphone</label>
                <input v-model="form.phone" type="tel" class="sf-input" placeholder="+237 6 XX XX XX XX" />
              </div>
              <div>
                <label class="sf-input-label sf-input-label--req">Sujet</label>
                <input v-model="form.subject" type="text" class="sf-input" placeholder="Objet de votre message" required />
              </div>
              <div>
                <label class="sf-input-label sf-input-label--req">Message</label>
                <textarea v-model="form.message" class="sf-input sf-textarea" rows="6" placeholder="Votre message…" required></textarea>
              </div>
              <button type="submit" class="sf-btn sf-btn--terra sf-btn--full" :disabled="loading">
                <span v-if="loading" class="sf-loader__ring" style="width:18px;height:18px;border-width:2px"></span>
                Envoyer le message
              </button>
            </form>
          </div>

          <!-- Info -->
          <div class="ct-info" data-aos="fade-left" data-aos-duration="700">
            <h2 class="sf-h2" style="margin-bottom:2rem">Informations de <em>contact</em></h2>
            <div class="ct-info-list">
              <div class="sf-info-row">
                <div class="sf-info-row__icon"><MapPin /></div>
                <div>
                  <p class="sf-info-row__label">Adresse</p>
                  <p class="sf-info-row__value">Oyack Source, Douala, Cameroun</p>
                </div>
              </div>
              <div class="sf-info-row">
                <div class="sf-info-row__icon"><Mail /></div>
                <div>
                  <p class="sf-info-row__label">Email</p>
                  <p class="sf-info-row__value">contact@stagfondation.org</p>
                  <p class="sf-info-row__value">info@stagconnect.org</p>
                </div>
              </div>
              <div class="sf-info-row">
                <div class="sf-info-row__icon"><Phone /></div>
                <div>
                  <p class="sf-info-row__label">Téléphone</p>
                  <a href="tel:+237561363798" class="sf-info-row__value">+237651363798</a>
               <a href="tel:+15145890214" class="sf-info-row__value">&nbsp; /+15145890214</a>
                  <!-- <a href="tel:+23751363798" class="sf-info-row__value">+237 51363798</a> -->
                </div>
              </div>
            </div>

            <div style="margin-top:2rem">
              <p class="sf-label">Suivez-nous</p>
              <div class="sf-socials">
                <a href="https://www.facebook.com/share/1Di2uv7XZn/" target="_blank" class="sf-social-btn"><Facebook /></a>
                <a href="#" class="sf-social-btn"><Twitter /></a>
                <a href="#" class="sf-social-btn"><Linkedin /></a>
                <a href="https://www.instagram.com/tchoun.dja" target="_blank" class="sf-social-btn"><Instagram /></a>
              </div>
            </div>

            <!-- Map placeholder -->
            <div class="ct-map">
              <MapPin class="ct-map__icon" />
              <p>Oyack Source, Douala, Cameroun</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Transition name="toast"><div v-if="toastMessage" class="sf-toast"><CheckCircle />{{ toastMessage }}</div></Transition>
  </main>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AOS from 'aos'; import 'aos/dist/aos.css'
import { MapPin, Mail, Phone, Facebook, Twitter, Linkedin, Instagram, CheckCircle } from 'lucide-vue-next'
export default {
  name:'ContactPage',
  components:{ MapPin, Mail, Phone, Facebook, Twitter, Linkedin, Instagram, CheckCircle },
  data(){return{form:{first_name:'',last_name:'',email:'',phone:'',subject:'',message:''}}},
  computed:{...mapState({loading:s=>s.loading,toastMessage:s=>s.toastMessage})},
  mounted(){AOS.init({once:true,offset:70,easing:'ease-out-cubic',duration:650})},
  methods:{
    ...mapActions(['submitContact']),
    async handleSubmit(){try{await this.submitContact(this.form);this.resetForm()}catch(e){console.error(e)}},
    resetForm(){this.form={first_name:'',last_name:'',email:'',phone:'',subject:'',message:''}}
  }
}
</script>
<style>@import './sf-design.css';</style>
<style scoped>
.ct-grid{display:grid;grid-template-columns:1fr 1fr;gap:4rem;align-items:start}
@media(max-width:900px){.ct-grid{grid-template-columns:1fr;gap:2.5rem}}
.ct-form-card{background:var(--white);border-radius:8px;padding:2.5rem 2rem;box-shadow:var(--shadow-sm)}
.ct-form{display:flex;flex-direction:column;gap:1.25rem}
.ct-form__row{display:grid;grid-template-columns:1fr 1fr;gap:1rem}
@media(max-width:540px){.ct-form__row{grid-template-columns:1fr}}
.ct-info-list{display:flex;flex-direction:column;gap:1.75rem}
.ct-map{margin-top:2rem;background:var(--cream-d);border-radius:8px;height:180px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.5rem;color:var(--ink-60)}
.ct-map__icon{width:32px;height:32px;color:var(--terra)}
.ct-map p{font-size:.85rem}
</style>
